import React from 'react'

import {Bell, DocumentSvg, User, Play, PauseFill, ImageIconSquare, SuccessIcon, Video} from "../assets/icons";
import Colors from "../themes/Colors";
import {mainPath} from "../routes/paths";

export const notificationsTypes = {
    DOCUMENT_UPLOADED: 'document_uploaded',

    REMEMBER_TO_ADD_REPORT: 'remember_to_add_report',
    DOCUMENT_UPLOADED_DOCUMENT: 'document_uploaded_document',
    DOCUMENT_UPLOADED_DRAWING: 'document_uploaded_drawing',
    DOCUMENT_UPLOADED_ESTIMATE: 'document_uploaded_estimate',

    //////// for clients who need approve or reject documents
    DOCUMENT_APPROVAL: 'document_approval',
    DOCUMENT_APPROVAL_DOCUMENT: 'document_approval_document',
    DOCUMENT_APPROVAL_DRAWING: 'document_approval_drawing',
    DOCUMENT_APPROVAL_ESTIMATE: 'document_approval_estimate',
    ////////

    //////// for admins who can see if document approved or rejected
    DOCUMENT_APPROVED: 'document_approved',
    DOCUMENT_REJECTED: 'document_rejected',

    ////////
    REPORT_UPLOAD: 'report_uploaded', //this type  for a next two types
    REPORT_UPLOAD_PHOTO: 'report_uploaded_photo',
    REPORT_UPLOAD_VIDEO: 'report_uploaded_video',
    ////////

    ////////
    EMOPLOYEE_CHANGED: 'emoployee_changed',
    MEMBER_ADDED: 'member_added',
    MEMBER_CHANGED: 'member_changed',
    ////////

    ////////
    PROJECT_PAUSED: 'project_paused',
    PROJECT_RESUMED: 'project_resumed',
    PROJECT_FINISHED: 'project_finished',
    ////////

    GENERAL: 'general'
}

export const notificationsReportsTypes = {
    PHOTO: 'image',
    VIDEO: 'video'
}
export const notificationsDocumentsTypes = {
    DOCUMENT: 'document',
    DRAWING: 'drawing',
    ESTIMATE: 'estimate'
}

export const notificationsTypesInfo = (t) => ({
    [notificationsTypes.DOCUMENT_UPLOADED]: {
        // title: 'Додано новий документ',
        title: t('notifications.types.documentUploaded.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        actionLabel: t('notifications.types.documentUploaded.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_UPLOADED_DOCUMENT]: {
        // title: 'Додано новий документ',
        title: t('notifications.types.documentUploadedDocument.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        // actionLabel: 'Відкрити документ',
        actionLabel: t('notifications.types.documentUploadedDocument.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_UPLOADED_DRAWING]: {
        // title: 'Додано нове креслення',
        title: t('notifications.types.documentUploadedDrawing.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        // actionLabel: 'Відкрити креслення',
        actionLabel: t('notifications.types.documentUploadedDrawing.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectDrawing.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_UPLOADED_ESTIMATE]: {
        title: t('notifications.types.documentUploadedEstimate.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        // actionLabel: 'Відкрити кошторис',
        actionLabel: t('notifications.types.documentUploadedEstimate.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectEstimate.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_APPROVAL]: {
        // title: 'Оновлено документ',
        title: t('notifications.types.documentApproval.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        // actionLabel: 'Відкрити документ',
        actionLabel: t('notifications.types.documentApproval.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_APPROVAL_DOCUMENT]: {
        // title: 'Оновлено документ',
        title: t('notifications.types.documentApprovalDocument.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        // actionLabel: 'Відкрити документ',
        actionLabel: t('notifications.types.documentApprovalDocument.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_APPROVAL_DRAWING]: {
        // title: 'Оновлено креслення',
        title: t('notifications.types.documentApprovalDrawing.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        // actionLabel: 'Відкрити креслення',
        actionLabel: t('notifications.types.documentApprovalDrawing.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_APPROVAL_ESTIMATE]: {
        // title: 'Оновлено кошторис',
        title: t('notifications.types.documentApprovalEstimate.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.notification2,
        // actionLabel: 'Відкрити кошторис',
        actionLabel: t('notifications.types.documentApprovalEstimate.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },

    [notificationsTypes.DOCUMENT_APPROVED]: {
        // title: 'Документ погодженно',
        title: t('notifications.types.documentApproved.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.accentGreen,
        // actionLabel: 'Відкрити документ',
        actionLabel: t('notifications.types.documentApproved.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },
    [notificationsTypes.DOCUMENT_REJECTED]: {
        // title: 'Документ відхиленно',
        title: t('notifications.types.documentRejected.title'),
        icon: props => <DocumentSvg {...props} />,
        color: Colors.accentRed,
        // actionLabel: 'Відкрити документ',
        actionLabel: t('notifications.types.documentRejected.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsDocument.replace(':id', params.projectId).replace(':documentId', params.documentId))
        }
    },

    [notificationsTypes.REPORT_UPLOAD_PHOTO]: {
        // title: 'Додано новий фото звіт',
        title: t('notifications.types.reportUploadPhoto.title'),
        icon: props => <ImageIconSquare {...props} />,
        color: Colors.accentOrange,
        // actionLabel: 'Відкрити фото звіт',
        actionLabel: t('notifications.types.reportUploadPhoto.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsReports.replace(':id', params.projectId))
        }
    },
    [notificationsTypes.REPORT_UPLOAD_VIDEO]: {
        // title: 'Додано новий відео звіт',
        title: t('notifications.types.reportUploadVideo.title'),
        icon: props => <Video {...props} />,
        color: Colors.blue,
        // actionLabel: 'Відкрити відео звіт',
        actionLabel: t('notifications.types.reportUploadVideo.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsReports.replace(':id', params.projectId) + '?tab=2')
        }
    },

    [notificationsTypes.EMOPLOYEE_CHANGED]: {
        // title: 'Оновлено співробітника',
        title: t('notifications.types.employeeChanged.title'),
        icon: props => <User {...props} />,
        color: Colors.accent2_dark,
        // actionLabel: 'Переглянути співробітника',
        actionLabel: t('notifications.types.employeeChanged.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsParticipants.replace(':id', params?.projectId));
        }
        // action: ({navigate, params}) => {
        // navigate(routes.privateScreens.projects.documents.detail, {
        //   projectId: params.projectId,
        //   name: params.projectAddress,
        //   docId: params.documentId,
        //   fileName: params.documentName,
        //   docType: params.type
        // })
        // }
    },
    [notificationsTypes.MEMBER_ADDED]: {
        // title: 'Додано учасника',
        title: t('notifications.types.memberAdded.title'),
        icon: props => <User {...props} />,
        color: Colors.accentGreen,
        // actionLabel: 'Переглянути учасників',
        actionLabel: t('notifications.types.memberAdded.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsParticipants.replace(':id', params?.projectId));
        }
    },
    [notificationsTypes.MEMBER_CHANGED]: {
        // title: 'Змінено учасника',
        title: t('notifications.types.memberChanged.title'),
        icon: props => <User {...props} />,
        color: Colors.yellow,
        // actionLabel: 'Переглянути учасників',
        actionLabel: t('notifications.types.memberChanged.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsParticipants.replace(':id', params.projectId))
        }
    },

    [notificationsTypes.PROJECT_PAUSED]: {
        // title: 'Проєкт призупиненно',
        title: t('notifications.types.projectPaused.title'),
        icon: props => <PauseFill {...props} />,
        color: Colors.yellow,
        // actionLabel: 'Переглянути проєкт',
        actionLabel: t('notifications.types.projectPaused.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.project.replace(':id', params.projectId))
        }
    },
    [notificationsTypes.PROJECT_RESUMED]: {
        // title: 'Проєкт відновлено',
        title: t('notifications.types.projectResumed.title'),
        icon: props => <Play {...props} />,
        color: Colors.accent2,
        // actionLabel: 'Переглянути проєкт',
        actionLabel: t('notifications.types.projectResumed.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.project.replace(':id', params.projectId))
        }
    },
    [notificationsTypes.PROJECT_FINISHED]: {
        // title: 'Проєкт завершено',
        title: t('notifications.types.projectFinished.title'),
        icon: props => <SuccessIcon {...props} />,
        color: Colors.accentGreen,
        // actionLabel: 'Переглянути проєкт',
        actionLabel: t('notifications.types.projectFinished.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.project.replace(':id', params.projectId))
        }
    },
    [notificationsTypes.GENERAL]: {
        // title: 'Сповіщення',
        title: t('notifications.types.general.title'),
        icon: props => <Bell {...props} />,
        color: Colors.accent1,
        actionLabel: '',
        action: null
    },
    [notificationsTypes.REMEMBER_TO_ADD_REPORT]: {
        // title: 'Додано новий документ',
        title: t('notifications.types.rememberToAddReport.title'),
        icon: props => <Bell {...props} />,
        color: Colors.blue,
        // actionLabel: 'Відкрити документ',
        actionLabel: t('notifications.types.rememberToAddReport.actionLabel'),
        action: ({history, params}) => {
            history.push(mainPath.projectsReports.replace(':id', params.projectId))
        }
    },
})

export const getNotificationType = (notification) => {
    if (Object.values(notificationsTypes).includes(notification.type)) {

        if (notification.type === notificationsTypes.REPORT_UPLOAD) {
            if (!!notification.messageBody && notification.messageBody.reportType === notificationsReportsTypes.PHOTO) {
                return notificationsTypes.REPORT_UPLOAD_PHOTO
            }
            if (!!notification.messageBody && notification.messageBody.reportType === notificationsReportsTypes.VIDEO) {
                return notificationsTypes.REPORT_UPLOAD_VIDEO
            }
        } else if (notification.type === notificationsTypes.DOCUMENT_APPROVAL) {
            if (!!notification.messageBody && notification.messageBody.documentType === notificationsDocumentsTypes.DOCUMENT) {
                return notificationsTypes.DOCUMENT_APPROVAL_DOCUMENT
            }
            if (!!notification.messageBody && notification.messageBody.documentType === notificationsDocumentsTypes.DRAWING) {
                return notificationsTypes.DOCUMENT_APPROVAL_DRAWING
            }
            if (!!notification.messageBody && notification.messageBody.documentType === notificationsDocumentsTypes.ESTIMATE) {
                return notificationsTypes.DOCUMENT_APPROVAL_ESTIMATE
            }
        } else if (notification.type === notificationsTypes.DOCUMENT_UPLOADED) {
            if (!!notification.messageBody && notification.messageBody.documentType === notificationsDocumentsTypes.DOCUMENT) {
                return notificationsTypes.DOCUMENT_UPLOADED_DOCUMENT
            }
            if (!!notification.messageBody && notification.messageBody.documentType === notificationsDocumentsTypes.DRAWING) {
                return notificationsTypes.DOCUMENT_UPLOADED_DRAWING
            }
            if (!!notification.messageBody && notification.messageBody.documentType === notificationsDocumentsTypes.ESTIMATE) {
                return notificationsTypes.DOCUMENT_UPLOADED_ESTIMATE
            }
        } else {
            return notification.type
        }
    }
    return notificationsTypes.GENERAL
}
